module.exports = "<div class=\"flex-align-start flex-wrap extra-preference-column max-h145\">\n    <div class='styleRadioCheckboxWrap checkbox c-checkbox ml0 mt0 mb18'\n         ng-repeat=\"item in ctrl.items | orderBy: 'Name'\">\n    <label class=\"width240\" title=\"{{::item.Name}}\">\n        <input type=\"checkbox\" ng-model=\"item.IsChecked\"/>\n        <span class='fa fa-check mr15'></span>\n        <ng-container ng-bind=\"::item.Name\"></ng-container>\n    </label>\n    </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.retailer/modules/extras/shared/checkboxes-group-list/checkboxes-group-list.component.html
// module id = 752
// module chunks = 0